import { membershipQueries } from "@features/membership/api/queryFactory";
import { reservationQueries } from "@features/reservation/api/queryFactory";
import { MeetingRoomDashboard } from "@features/reservation/ui";
import { BaseLayout } from "@layouts/ui";
import { createFileRoute, redirect } from "@tanstack/react-router";
import dayjs from "dayjs";

export const Route = createFileRoute("/_authenticated/reserve")({
  beforeLoad: async ({ context }) => {
    // 미팅룸은 SILVER 멤버십만 이용 가능. 그 외(Virtual Address/Day Pass 등)는 진입 차단
    const membership = await context.queryClient.fetchQuery(membershipQueries.membership());
    if (membership?.plan_description?.type !== "SILVER") {
      throw redirect({ to: "/" });
    }
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(reservationQueries.meetingRooms(dayjs().format("YYYY-MM-DD")));

    return null;
  },
  component: ReservePage,
});

function ReservePage() {
  return (
    <BaseLayout>
      <div className="min-h-[calc(100vh-58px)] md:min-h-[calc(100vh-80px)] py-8">
        <div className="w-full max-w-[816px] mx-auto px-4">
          <MeetingRoomDashboard />
        </div>
      </div>
    </BaseLayout>
  );
}
